import { ExperiencePerformanceTypes, ExperienceTypes } from '@atlassian/ufo';
export var commonExperienceConfig = {
  type: ExperienceTypes.Experience,
  performanceType: ExperiencePerformanceTypes.InlineResult
};